import type { StudentClaim } from "@/api/studentClaims";
import { captureStudentClaimConfirmedEvent } from "@/utils/posthogUtils";

export type ReportStudentClaimsConfirmedContext = {
	loggedInTeacherUsername: string;
	applianceId: string;
	managementClaimedByClassroom: string;
};

/**
 * Emits one `student_claim_confirmed` PostHog event per successfully claimed student when context is complete.
 */
export function reportStudentClaimsConfirmedAnalytics(
	studentIds: string[],
	claimsSnapshot: StudentClaim[],
	ctx: ReportStudentClaimsConfirmedContext
): void {
	if (!ctx.loggedInTeacherUsername || !ctx.applianceId || !ctx.managementClaimedByClassroom) {
		return;
	}
	for (const studentId of studentIds) {
		const claim = claimsSnapshot.find((c) => c.studentId === studentId);
		if (!claim) {
			continue;
		}
		captureStudentClaimConfirmedEvent({
			applianceId: ctx.applianceId,
			studentUsername: claim.studentUsername,
			managementClaimedFromTeacher: claim.teacherUsername,
			loggedInTeacherUsername: ctx.loggedInTeacherUsername,
			managementClaimedByClassroom: ctx.managementClaimedByClassroom,
			managementClaimedFromClassroom: claim.className,
		});
	}
}
